import { Link } from 'react-router-dom'
import FinishGrid from '../components/FinishGrid.jsx'

// Landing page for the six finishes. Customers pick a colour first and buy the whole
// bathroom's worth of hardware from that one page.
export default function HardwareFinishes() {
  return (
    <main className="container page">
      <nav className="breadcrumbs" aria-label="Breadcrumb">
        <Link to="/">Home</Link> / <Link to="/shop">Shop</Link> / <Link to="/shop/hardware">Hardware</Link> / <span>Finishes</span>
      </nav>
      <header className="page-head">
        <h1>Shower Screen Hardware by Finish</h1>
        <p>
          Hinges, clamps, brackets, knobs and channel for 10mm frameless glass — solid brass
          with a PVD finish, in six colours. Pick your finish and add the whole list to your
          cart from one page.
        </p>
      </header>

      <FinishGrid />

      <p className="finish-foot muted">
        Need a complete screen instead of parts? <Link to="/shop/shower-screens">See the shower screen packages</Link>,
        or <Link to="/shop/hardware">browse all hardware</Link> including seals and water bars.
      </p>
    </main>
  )
}
